import React from 'react';
import withStyles from '@mui/styles/withStyles';
import styles from './DataGrid.styles';
import { DataGrid as MuiDatagrid, GridOverlay, GridToolbarContainer } from '@mui/x-data-grid';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

const DataGrid = ({ classes, className, height, actions, noRowsText, 'data-test': dataTest, ...props }) => {
  const Toolbar = () => (
    <GridToolbarContainer>
      {actions?.map(({ label, icon, tooltip, color, disabled, onClick, ...props }, index) => (
        <Tooltip key={index} title={tooltip || ''} placement="top" arrow>
          <span>
            <Button startIcon={icon} color={color || 'primary'} disabled={disabled} onClick={onClick} {...props}>
              {label}
            </Button>
          </span>
        </Tooltip>
      ))}
    </GridToolbarContainer>
  );

  const NoRowsOverlay = () => <GridOverlay>{noRowsText}</GridOverlay>;

  return (
    <div style={{ height }} data-test={dataTest}>
      <MuiDatagrid
        className={classNames(classes.datagrid, className)}
        autoHeight
        density="standard"
        pagination
        pageSize={10}
        rowsPerPageOptions={[props.pageSize || 10]}
        {...props}
        components={{
          Toolbar: actions && Toolbar,
          NoRowsOverlay: noRowsText && NoRowsOverlay
        }}
      />
    </div>
  );
};

export default withStyles(styles)(DataGrid);
